import { render, staticRenderFns } from "./student-attendance-view.vue?vue&type=template&id=203428dd&scoped=true&"
import script from "./student-attendance-view.vue?vue&type=script&lang=js&"
export * from "./student-attendance-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203428dd",
  null
  
)

export default component.exports